export default "__VITE_ASSET__55a610c8__"